import IconButton from './reusables/IconButton';

interface EngagementTableIconsProps {
    onEdit: () => void;
    onDelete?: () => void;
    onShare?: () => void;
    onGo?: () => void;
}
const EngagementTableIcons = ({
    onEdit,
    onDelete,
    onShare,
    onGo,
}: EngagementTableIconsProps) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '4px',
            }}
        >
            {onDelete && (
                <IconButton
                    onClick={onDelete}
                    icon="Appkit4-icon icon-delete-outline"
                    title="Delete"
                />
            )}
            <IconButton
                onClick={onEdit}
                icon="Appkit4-icon icon-edit-outline"
                title="Edit"
            />
            {onShare && (
                <IconButton
                    onClick={onShare}
                    icon="Appkit4-icon icon-share-outline"
                    title="Share"
                />
            )}
            {onGo && (
                <IconButton
                    onClick={onGo}
                    icon="Appkit4-icon icon-arrow-right-outline"
                    title="Go"
                    testId="engagement-open-button"
                />
            )}
        </div>
    );
};

export default EngagementTableIcons;
